import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';

const propTypes = {
    tag: tagPropType,
    className: PropTypes.string,
    cssModule: PropTypes.object,
};

const defaultProps = {
    tag: 'div'
};

const CardFooter = ({ className, cssModule, tag: Tag, ...attributes }) => {
    const classes = mapToCssModules(classNames(
        className,
        'bot-card-footer'
    ), cssModule);

    return (
        <Tag {...attributes} className={classes} />
    );
};

CardFooter.propTypes = propTypes;
CardFooter.defaultProps = defaultProps;

export default CardFooter;
